import { ProjectRepository } from '@/domain/project/ProjectRepository';
import { AxiosInstance } from 'axios';
import { Project } from '@/domain/project/Project';
import { RestProject, toProject } from '@/secondary/project/RestProject';
import { NotFound } from '@/domain/NotFound';
import { RestPagination } from '@/secondary/pagination/RestPagination';

export class RestProjectRepository implements ProjectRepository {
  constructor(private axiosInstance: AxiosInstance) {}

  list(): Promise<Project[]> {
    return this.axiosInstance
      .get<RestPagination<RestProject>>('projects?page=1&size=1000')
      .then(response => response.data.content.map(toProject))
      .catch(error => {
        throw new NotFound('Project').cause(error);
      });
  }
}
